import { createFileRoute } from '@tanstack/react-router';
import { IconBriefcase } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import { QuickCreateButton, type FieldDef } from '@/shared/components/QuickCreateButton';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface External extends Denormalized {
  type: 'erp-external-worker-details';
  vatNumber?: string;
  contractDetails?: string;
  paymentFrequency?: string;
  hourlyRate?: number;
}

const FIELDS: FieldDef[] = [
  { name: 'vatNumber', label: 'Partita IVA', required: true },
  { name: 'contractDetails', label: 'Dettagli contratto', kind: 'textarea' },
  {
    name: 'paymentFrequency', label: 'Frequenza pagamento', kind: 'select', defaultValue: 'monthly',
    options: [
      { value: 'monthly', label: 'Mensile' },
      { value: 'weekly', label: 'Settimanale' },
      { value: 'project', label: 'A progetto' },
    ],
  },
  { name: 'hourlyRate', label: 'Tariffa oraria €', kind: 'number' },
];

export const Route = createFileRoute('/_app/workforce/external')({ component: ExternalPage });

function ExternalPage() {
  return (
    <ResourceListPage<External>
      title=""
      type="erp-external-worker-details"
      columns={[
        { accessorKey: 'vatNumber', header: 'P.IVA' },
        { accessorKey: 'paymentFrequency', header: 'Frequenza' },
        { accessorKey: 'hourlyRate', header: '€/ora', size: 100 },
      ]}
      searchField="vatNumber"
      emptyMessage="Nessun collaboratore esterno"
      emptyDescription="Registra il primo collaboratore con il bottone «Nuovo collaboratore» nella toolbar."
      emptyIcon={IconBriefcase}
      editFields={FIELDS}
      editTitle="Modifica collaboratore"
      enableDelete
      getRowLabel={(r) => r.vatNumber ?? r.id}
      toolbarRight={<QuickCreateButton type="erp-external-worker-details" title="Nuovo collaboratore" fields={FIELDS} />}
    />
  );
}
